<script setup lang="ts">
import { NModal } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  show?: boolean
  title?: string
  size?: 'small' | 'medium' | 'large' | 'huge'
  preset?: 'card' | 'dialog'
  displayDirective?: 'if' | 'show'
  maskClosable?: boolean
  closable?: boolean
  autoFocus?: boolean
  trapFocus?: boolean
  closeOnEsc?: boolean
  showMask?: boolean
  blockScroll?: boolean
  to?: string | HTMLElement
  zIndex?: number
  transformOrigin?: 'mouse' | 'center'
  onUpdateShow?: (show: boolean) => void
  onAfterEnter?: () => void
  onAfterLeave?: () => void
  onEsc?: () => void
  onMaskClick?: () => void
  onClose?: () => void
}>(), {
  show: false,
  title: undefined,
  size: 'medium',
  preset: 'dialog',
  displayDirective: 'if',
  maskClosable: false,
  closable: false,
  autoFocus: false,
  trapFocus: false,
  closeOnEsc: false,
  to: undefined,
  zIndex: undefined,
  transformOrigin: 'center',
  showMask: true,
  blockScroll: true,
})

const emit = defineEmits<{
  'update:show': [show: boolean]
  'after-enter': []
  'after-leave': []
  'esc': []
  'mask-click': []
  'close': []
}>()

const attrs = useAttrs()

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
}

const onAfterEnter = () => {
  emit('after-enter')
}

const onAfterLeave = () => {
  emit('after-leave')
}

const onEsc = () => {
  emit('esc')
}

const onMaskClick = () => {
  emit('mask-click')
}

const onClose = () => {
  emit('close')
}
</script>

<template>
  <NModal
    :show="show"
    :title="title"
    :size="size"
    :preset="preset"
    :display-directive="displayDirective"
    :mask-closable="maskClosable"
    :closable="closable"
    :auto-focus="autoFocus"
    :trap-focus="trapFocus"
    :close-on-esc="closeOnEsc"
    :to="to"
    :z-index="zIndex"
    :transform-origin="transformOrigin"
    :show-mask="showMask"
    :block-scroll="blockScroll"
    v-bind="attrs"
    @update:show="onUpdateShow"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
    @esc="onEsc"
    @mask-click="onMaskClick"
    @close="onClose"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #header-extra>
      <slot name="header-extra" />
    </template>
    <template #default>
      <slot />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
    <template #action>
      <slot name="action" />
    </template>
  </NModal>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
